import store from '@/store'
import { getBrandConfig } from '@/brand'

export const DEFAULT_UNSUBSCRIBE_INSTRUCTIONS = Object.freeze({
  ussd: '*135*997#',
  app: 'VodaPay app'
})

function resolveBrandConfig() {
  return store?.state?.brandConfig || (typeof getBrandConfig === 'function' ? getBrandConfig() : null)
}

export function VodacomUnSubPopUp() {
  return resolveBrandConfig()?.unsubscribeViaUssd === true
}

export function getUnsubscribeInstructions() {
  const config = resolveBrandConfig()
  return { ...DEFAULT_UNSUBSCRIBE_INSTRUCTIONS, ...(config?.unsubscribeInstructions || {}) }
}

export default VodacomUnSubPopUp
